import './mariasgourmet/style';
import FormStructure from './mariasgourmet/form_structure';

export default FormStructure;